import * as React from "react";
import { UserAvatar, UserAvatarUserT } from "@talentpair/quantic";
import { displayFullName } from "@talentpair/entities/user";
import { UserMessageT } from "../types";
import { MessageListItem } from "./MessageListItem";

export type UserMessageProps = UserMessageT & {
  last?: boolean;
  user?: UserAvatarUserT;
};

export function UserMessage({ user, message, last }: UserMessageProps): React.ReactElement {
  return (
    <MessageListItem
      last={last}
      avatar={user ? <UserAvatar user={user} /> : undefined}
      title={displayFullName(user || {}, "Guest")}
      content={message}
    />
  );
}
